import type { ITool, IToolContext } from '../../core/tools/interfaces/ITool';
import type { ToolRegistry } from '../../core/tools/ToolRegistry';

type PrepareShapeToolbarDeleteOptions = {
  toolRegistry: ToolRegistry;
  toolContext: IToolContext;
  selectedShapeIds: string[];
};

/**
 * Align the registry with the selection that rendered the shape toolbar before
 * resolving the domain delete tool. React selection can render one tick before
 * the canvas effect publishes that same selection to the registry.
 */
export function prepareShapeToolbarDelete({
  toolRegistry,
  toolContext,
  selectedShapeIds,
}: PrepareShapeToolbarDeleteOptions): ITool | null {
  const selection = selectedShapeIds.length > 0
    ? new Set(selectedShapeIds)
    : new Set(toolContext.selection);

  toolRegistry.updateContext({
    selection,
    diagramType: toolContext.diagramType,
  });

  const preferredId = toolContext.diagramType === 'genogram' ? 'genogram-delete' : 'delete';
  return toolRegistry.getTool(preferredId) ?? toolRegistry.getTool('delete') ?? null;
}
